import React from 'react';
import { ArrowLeft, Maximize2, Minimize2 } from 'lucide-react';
import { isMobile } from '../../utils/mobileUtils';
import { ProfileAvatar, UserProfilePopover } from '../ui';
import UserActionsDropdown from '../ui/UserActionsDropdown';

interface ConversationHeaderProps {
  user: {
    id: string;
    username: string;
    profilePhoto: string | null;
  };
  onBack?: () => void;
  showBackButton?: boolean;
  isFullscreen?: boolean;
  onToggleFullscreen?: () => void;
}

const ConversationHeader: React.FC<ConversationHeaderProps> = ({
  user,
  onBack,
  showBackButton = false,
  isFullscreen = false,
  onToggleFullscreen
}) => {
  return (
    <div
      className="border-b border-white/[.08] px-4 py-3"
      style={{ background: 'linear-gradient(90deg, rgba(255,61,129,.1), rgba(35,229,219,.06))' }}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-3">
          {showBackButton && onBack && (
            <button
              onClick={onBack}
              className="p-2 hover:bg-white/[.06] rounded-xl transition-colors lg:hidden"
              title="Terug naar gesprekken"
            >
              <ArrowLeft className="h-5 w-5 text-neon-cyan" />
            </button>
          )}

          <UserProfilePopover
            userId={parseInt(user.id)}
            placement="bottom"
            trigger={
              <div className="flex items-center space-x-3 cursor-pointer hover:bg-white/[.06] rounded-xl p-2 -m-2 transition-colors">
                <ProfileAvatar user={user} size="md" />
                <div>
                  <h2 className="font-semibold text-fg-bright">{user.username}</h2>
                  <p className="text-sm text-fg-muted">Klik om profiel te bekijken</p>
                </div>
              </div>
            }
          />
        </div>

        <div className="flex items-center space-x-2">
          {/* Fullscreen toggle - only show on desktop */}
          {!isMobile() && onToggleFullscreen && (
            <button
              onClick={onToggleFullscreen}
              className="p-2 text-fg-muted hover:text-neon-cyan hover:bg-white/[.06] rounded-xl transition-colors"
              title={isFullscreen ? "Venster verkleinen" : "Volledig scherm"}
            >
              {isFullscreen ? (
                <Minimize2 className="h-5 w-5" />
              ) : (
                <Maximize2 className="h-5 w-5" />
              )}
            </button>
          )}

          <UserActionsDropdown
            userId={parseInt(user.id)}
            username={user.username}
            className="text-fg-muted hover:text-neon-cyan"
          />
        </div>
      </div>
    </div>
  );
};

export default ConversationHeader;